var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-reminder-panel-body-users"},_vm._l((_vm.users),function(user){return _c('div',{key:user._id,class:[
      'bbp-reminder-panel-body-users__image',
      !user.image && 'bbp-reminder-panel-body-users__image_default'
    ]},[_c('img',{attrs:{"src":_vm.getUserImage(user),"alt":""}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262e816e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelBody/BBPReminderPanelBodyUsers.vue
// module id = null
// module chunks = 